import { createClient, type Session } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Foundation-Phase: env-vars kommen via `vercel env pull`.
  console.warn("VITE_SUPABASE_URL / _ANON_KEY fehlt — UI läuft, API-Calls failen.");
}

export const supabase = createClient(url ?? "http://localhost:54321", anonKey ?? "anon-placeholder", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export type Role = "admin" | "buero" | "dispatch" | "fahrer" | "kunde_privat" | "kunde_edeka";

export function roleFromSession(session: Session | null): Role {
  const role = (session?.user?.app_metadata as { role?: string } | undefined)?.role;
  return (role as Role) ?? "kunde_privat";
}
